var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FontPicker',{staticClass:"ws-font-picker",attrs:{"auto-load":"","no-maches":"Font not found"},model:{value:(_vm.font),callback:function ($$v) {_vm.font=$$v},expression:"font"}})
}
var staticRenderFns = []

export { render, staticRenderFns }